import { useCallback, useEffect, useState } from 'react';
import { DataProviderInstance } from '../../api/DataProvider';

/**
 * Faixas de sala de todas as agendas num dia (YYYY-MM-DD). `date` vazio não busca.
 * `reload()` depois de aplicar uma sala.
 */
export default function useDayRooms(date) {
  const { GetDayRooms } = DataProviderInstance();
  const [assignments, setAssignments] = useState([]);
  const [loadedDate, setLoadedDate] = useState(null);

  const reload = useCallback(() => {
    if (!date) return;
    GetDayRooms(date, (result) => {
      if (result?.status !== 'SUCCESS') return;
      setAssignments(result.data?.assignments || []);
      setLoadedDate(result.data?.date || date);
    });
  }, [date, GetDayRooms]);

  useEffect(() => {
    let active = true;
    if (!date) {
      setAssignments([]);
      setLoadedDate(null);
      return undefined;
    }
    GetDayRooms(date, (result) => {
      if (!active || result?.status !== 'SUCCESS') return;
      setAssignments(result.data?.assignments || []);
      setLoadedDate(result.data?.date || date);
    });
    return () => { active = false; };
  }, [date, GetDayRooms]);

  return { assignments, isLoaded: loadedDate === date, reload };
}
